import { motion } from "framer-motion";

const steps = [
  {
    number: "01",
    title: "Mint",
    body: "Pay 0.0025 ETH to mint a random Cat Claw NFT. Only 1,024 will ever exist.",
  },
  {
    number: "02",
    title: "Activate",
    body: "Burn 25,000 $CATCLAW to wake your cat up and start earning hourly rewards.",
  },
  {
    number: "03",
    title: "Split",
    body: "Choose how hourly rewards are split between NVDA, SPCX, and SPY stock tokens.",
  },
  {
    number: "04",
    title: "Climb",
    body: "Burn more $CATCLAW to climb tiers. Multipliers go from 1× up to 3.5×.",
  },
];

export function StepsSection() {
  return (
    <section className="bg-card/30 py-20 md:py-28">
      <div className="container mx-auto max-w-6xl px-4">
        <div className="mb-12 max-w-2xl">
          <p className="font-pixel text-xs text-[var(--accent-green)]">FOUR STEPS</p>
          <h2 className="mt-2 font-pixel text-2xl text-foreground md:text-4xl">
            THEN IT RUNS ITSELF.
          </h2>
          <p className="mt-3 text-muted-foreground">
            Set it up once. Your cat fills up with stock tokens while you sleep.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="rounded-2xl border border-border bg-card p-6 transition-colors hover:border-[var(--accent-green)]/30"
            >
              <span className="font-pixel text-3xl text-[var(--accent-green)]">{step.number}</span>
              <h3 className="mt-4 text-lg font-bold text-foreground">{step.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{step.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
